import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ShieldCheck, Award, TrendingUp, Sparkles, CheckCircle2 } from 'lucide-react';
import CSIIntroImage from '../../../../../../Assets/csi_intro.jpg';
import InforAlliancePartnerLogo from '../../../../../../Assets/Logo/InforAlliancePartner.png';

const heroImage = CSIIntroImage;

const stats = [
  { value: '100+', label: 'Enterprise Deployments', detail: 'Across Global Facilities' },
  { value: '35%', label: 'Faster Order-to-Cash', detail: 'Automated Lifecycle' },
  { value: '99.9%', label: 'Cloud Availability', detail: 'Multi-Tenant AWS SLA' },
  { value: '24/7', label: 'Global Advisory', detail: 'Follow-the-Sun Support' },
];

const Intro = () => {
  return (
    <section
      className="relative flex min-h-[85vh] items-center overflow-hidden px-4 py-20 sm:px-6 lg:px-8"
      style={{
        backgroundImage: `linear-gradient(90deg, rgba(10, 22, 40, 0.82) 0%, rgba(15, 30, 54, 0.56) 45%, rgba(24, 49, 89, 0.16) 100%), url(${heroImage})`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      }}
    >
      {/* Decorative ambient glow */}
      <div
        className="pointer-events-none absolute -top-24 -left-24 h-96 w-96 rounded-full blur-3xl"
        style={{ background: 'radial-gradient(circle, rgba(37, 99, 235, 0.3) 0%, transparent 70%)' }}
      />
      <div
        className="pointer-events-none absolute bottom-0 right-0 h-96 w-96 rounded-full blur-3xl"
        style={{ background: 'radial-gradient(circle, rgba(14, 165, 233, 0.2) 0%, transparent 70%)' }}
      />

      {/* Subtle bottom gradient transition */}
      <div
        className="absolute inset-x-0 bottom-0 h-28 pointer-events-none"
        style={{
          background: 'linear-gradient(180deg, rgba(10, 22, 40, 0) 0%, rgba(10, 22, 40, 0.72) 100%)',
        }}
      />

      <div className="relative z-10 mx-auto w-full max-w-7xl">
        <div className="grid items-center gap-12 lg:grid-cols-12">
          {/* Main Content Column */}
          <div className="lg:col-span-8">
            {/* Top Pill with Alliance Partner */}
            {/* <div className="mb-6 flex flex-wrap items-center gap-3">
              <div
                className="inline-flex items-center gap-2 rounded-full border px-4 py-1.5 text-xs font-semibold uppercase tracking-wider backdrop-blur-md"
                style={{
                  backgroundColor: 'rgba(255, 255, 255, 0.08)',
                  borderColor: 'rgba(56, 189, 248, 0.35)',
                  color: '#38BDF8',
                }}
              >
                <Sparkles className="h-3.5 w-3.5" style={{ color: '#38BDF8' }} />
                <span>Next-Gen Industrial ERP</span>
              </div>

              <div
                className="inline-flex items-center gap-2 rounded-full border px-3 py-1 text-xs font-medium backdrop-blur-md"
                style={{
                  backgroundColor: 'rgba(255, 255, 255, 0.06)',
                  borderColor: 'rgba(255, 255, 255, 0.16)',
                  color: '#E2E8F0',
                }}
              >
                <ShieldCheck className="h-3.5 w-3.5" style={{ color: '#10B981' }} />
                <span>Certified Infor Alliance Partner</span>
              </div>
            </div> */}

            {/* Headline */}
            <h1
              className="text-2xl font-bold leading-tight sm:text-3xl md:text-4xl"
              style={{ color: '#FFFFFF', fontFamily: "'Satoshi', sans-serif" }}
            >
              Enterprise Agility. Intelligent Manufacturing{' '}
              <span
              className='text-2xl font-bold leading-tight sm:text-3xl md:text-4xl'
                style={{
                  background: 'linear-gradient(90deg, #38BDF8 0%, #60A5FA 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                }}
              >
                Accelerated with Infor CSI
              </span>
            </h1>

            {/* Subtitle */}
            <p
              className="mt-6 max-w-2xl text-base leading-8 sm:text-lg"
              style={{ color: '#FFFFFF', fontFamily: "'Satoshi', sans-serif",wordBreak: 'normal',overflowWrap: 'normal',hyphens: 'none',whieSpace: 'normal' }}
            >
              Empower discrete and complex manufacturers to unify Advanced Planning & Scheduling (APS), 
              automate shop-floor telemetry, and synchronize global supply networks on Infor CloudSuite Industrial (SyteLine).
            </p>

            {/* CTA Group */}
            <div className="mt-8 flex flex-col sm:flex-row items-stretch sm:items-center gap-4">
              <Link to="/contact" onClick={() => window.scrollTo(0, 0)}>
                <button
                  type="button"
                  className="group inline-flex w-full sm:w-auto items-center justify-center gap-3 rounded-xl px-7 py-4 text-base font-bold transition-all duration-300 hover:shadow-xl hover:-translate-y-0.5"
                  style={{
                    backgroundColor: '#2563EB',
                    color: '#FFFFFF',
                    boxShadow: '0 12px 30px rgba(37, 99, 235, 0.45)',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#1D4ED8';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#2563EB';
                  }}
                >
                  <span>Talk to an Infor CSI Expert</span>
                  <ArrowRight className="h-5 w-5 transition duration-300 group-hover:translate-x-1" />
                </button>
              </Link>
            </div>
          </div>

          {/* Right Brand Card with Partner Logo */}

        </div>

      </div>
    </section>
  );
};

export default Intro;
